import { Spinner } from "react-bootstrap";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { mappingBatchPut } from "../../../../../api/index.js";
import { useDispatch } from "react-redux";
import { buildAlert } from "../../../../../actions/index.js";
import { SettingsProcountorContext } from "../SettingsProcountorContext.jsx";
import { Button } from "../../../../../common/Button.tsx";
import { useGetAllAbsenceSalaryMappings } from "../../../../../api/endpoints/calendar-data-rest-controller/calendar-data-rest-controller.ts";

export const EventMappingSave = ({ closeModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { editedCells, setEditedCells } = useContext(SettingsProcountorContext);
  const { refetch } = useGetAllAbsenceSalaryMappings();

  const {
    mutate,
    isPending: isEditingLoading,
    isSuccess: isEditingSuccess,
    isError: isEditingError,
    error,
  } = useMutation({
    mutationFn: (json) => mappingBatchPut(json),
  });

  const editEventMapping = async () => {
    const hasInvalidRows = editedCells.some((row) => {
      const salaryCode = row?.salaryTypeCode;
      const active = row?.active;
      return !salaryCode && active;
    });

    if (hasInvalidRows) {
      dispatch(
        buildAlert("ERROR", t("Error", "Virhe"), t("Salary Type code is required", "Palkkalaji on pakollinen tieto")),
      );
      return;
    }
    mutate(editedCells);
  };

  useEffect(() => {
    if (isEditingError && error.response?.data) {
      dispatch(buildAlert("ERROR", error.response.data.error, error.response.data.message));
    }
  }, [isEditingError, error]);

  useEffect(() => {
    if (!isEditingSuccess) return;
    refetch().then(() => {
      setEditedCells([]);
      closeModal();
    });
  }, [isEditingSuccess]);

  return (
    <Button
      key="key"
      variant="primary"
      onClick={editEventMapping}
      disabled={editedCells.length === 0}
      className="d-flex align-items-center gap-1"
    >
      {isEditingLoading && <Spinner animation="border" role="status" variant="light" size="sm" />}
      {t("Save", "Tallenna")}
    </Button>
  );
};
